"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constellation = require("@zillow/constellation");
var _OutputCard = _interopRequireDefault(require("./OutputCard"));
var _InputAndSlider = _interopRequireDefault(require("./InputAndSlider"));
var S = _interopRequireWildcard(require("./styles"));
var _hooks = require("./hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Components
// Misc / Utils
/* eslint-disable @typescript-eslint/no-unused-vars */
var RoiCalc = function RoiCalc(_ref) {
  var _ref$itc = _ref.itc,
    itc = _ref$itc === void 0 ? '' : _ref$itc,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? '' : _ref$t,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? 'Rental Property ROI Calculator' : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? 'Calculate your potential return on investment' : _ref$subheading;
  /* eslint-enable */
  var _useCalculator = (0, _hooks.useCalculator)(),
    inputs = _useCalculator.inputs,
    outputs = _useCalculator.outputs,
    years = _useCalculator.years,
    setYears = _useCalculator.setYears,
    totalReturn = _useCalculator.totalReturn;
  var handleSelectYears = function handleSelectYears(value) {
    setYears(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, {
    theme: _constellation.ThemeConstellation,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(S.Container, {
      cardType: "secondary",
      padding: "sm",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Text, {
        as: "h2",
        fontType: "h4",
        children: heading
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Text, {
        as: "div",
        fontType: "bodySmall",
        marginBottom: "xs",
        children: subheading
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Flex, {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        children: inputs.map(function (inputObj, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAndSlider["default"], _objectSpread({}, inputObj), i);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.ToggleButtonGroup, {
        defaultValue: years.toString(),
        onChange: handleSelectYears,
        fluid: true,
        paddingY: "sm",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(S.ToggleButton, {
          value: "5",
          children: "5 years"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.ToggleButton, {
          value: "10",
          children: "10 years"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.ToggleButton, {
          value: "20",
          children: "20 years"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.ToggleButton, {
          value: "30",
          children: "30 years"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(S.OutputsContainer, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(S.OutputsPairContainer, {
          children: outputs.slice(0, 2).map(function (outputObj, i) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutputCard["default"], _objectSpread({}, outputObj), i);
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.OutputsPairContainer, {
          children: outputs.slice(2, 4).map(function (outputObj, i) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutputCard["default"], _objectSpread({}, outputObj), i);
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Flex, {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginY: "sm",
        padding: "xs",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Text, {
          fontType: "body",
          children: "Total return: "
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Text, {
          fontType: "h3",
          marginLeft: "md",
          children: totalReturn
        })]
      })]
    })
  });
};
var _default = exports["default"] = RoiCalc;